import React, { memo, useMemo, useState, useEffect } from 'react';
import { ENTITIES } from 'lib/constants';
import { useWeb5Context } from 'lib/Web5Context';
import { getExtraFieldEntities } from 'lib/services/fields';
import SectionTabs from 'components/SectionTabs';
import { getDescription } from 'utils/custom';

export const defaultTabs = [
    {
        key: ENTITIES.ACCOUNTS.fields,
        title: 'cfm_label_accounts',
    },
    {
        key: ENTITIES.CONTACTS.fields,
        title: 'cfm_label_contacts',
    },
    {
        key: ENTITIES.OPPORTUNITIES.fields,
        title: 'cfm_label_opportunities',
    },
    {
        key: ENTITIES.ACTIVITIES.fields,
        title: 'cfm_label_activities',
    },
    {
        key: ENTITIES.CALENDAR.fields,
        title: 'cfm_label_event_task',
    },
    {
        key: ENTITIES.SALESORDERS.fields,
        title: 'cfm_label_salesorders',
    },
    {
        key: ENTITIES.PRODUCTS.fields,
        title: 'cfm_label_products',
    },
    {
        key: ENTITIES.USERS.fields,
        title: 'cfm_label_users',
    },
];

const FieldsTabs = ({
    onChange,
    onChangeShrinked,
    activeTab,
    activeShrinkedTab,
    setEntities,
    idSetupRole,
    overrides,
}) => {
    const {
        t,
        tabsPermissions,
        getViewsInGetExtraFieldEntities = true,
    } = useWeb5Context({ overrides });
    const [shrinkedTabs, setShrinkedTabs] = useState();

    const tabs = useMemo(() => {
        let tabs = defaultTabs.map(({ key, title }) => ({ key, title: t(title) }));
        if (tabsPermissions) tabs = tabs.filter((tab) => tabsPermissions[tab.key]);
        return tabs;
    }, [t, tabsPermissions]);

    const dumbUser = idSetupRole ? [8, 9].includes(idSetupRole) : false;

    useEffect(() => {
        !shrinkedTabs &&
            getExtraFieldEntities(getViewsInGetExtraFieldEntities)
                .then(({ data }) => {
                    if (!data) return;
                    setEntities(data);
                    if (!tabsPermissions || tabsPermissions?.otherTables) {
                        setShrinkedTabs(
                            data
                                .filter(
                                    ({ name }) =>
                                        !tabs.find(
                                            (tab) => name.toLowerCase() === tab.key.toLowerCase(),
                                        ),
                                )
                                .filter((data) => !data.isView)
                                .map((tab) => ({
                                    label: getDescription({ tab, dumbUser }),
                                    value: tab.name,
                                })),
                        );
                    }
                })
                .catch(console.error);
    }, [
        setEntities,
        setShrinkedTabs,
        shrinkedTabs,
        tabs,
        dumbUser,
        tabsPermissions,
        getViewsInGetExtraFieldEntities,
    ]);

    return (
        <div id="fm-fields__tabs">
            <SectionTabs
                onChangeShrinked={onChangeShrinked}
                onChange={onChange}
                activeTab={activeTab}
                activeShrinkedTab={activeShrinkedTab}
                tabs={tabs}
                shrinkedTabs={shrinkedTabs}
            />
        </div>
    );
};

export default memo(FieldsTabs);
